/*
 * COPYRIGHT (c) 2024
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';

import { IIndependentVarProps } from '../Model';
import { Checkbox, Input, Select } from '@scuf/common';
import _ from 'lodash';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../../../locales/en-US/descriptors';
import { IOption } from '@scuf/common/dist/components/Select/ISelectProps';

import './DropdownVariableTheme.scss';

export interface IDropdownIndependentVarProps
  extends IIndependentVarProps<string> {
  displayName: string;
  allowedValues: IOption[];
  inputLabel: string;
  inputValue: string;
  inputOnChange: (val: string) => void;
}

export const DropdownIndependentVar = (props: IDropdownIndependentVarProps) => {
  const baselineConfigDesc = descriptors.baseline;
  const [t] = useTranslation();

  const {
    allowedValues,
    inputLabel,
    inputUnit,
    inputValue,
    disabled,
    displayName,
    checked,
    onCheckBoxChange,
    inputOnChange,
    hasTStat,
    tStatValue,
    inputDisabled
  } = props;

  return (
    <div className="common-input-wrapper indep-var-dropdown-wrapper">
      <div className="label">
        <Checkbox
          label={displayName}
          checked={checked}
          onChange={(checked) => onCheckBoxChange(checked)}
          disabled={disabled}
        />
      </div>
      <div className="select-wrapper">
        <Select
          label={inputLabel}
          options={allowedValues!.map((val) => ({
            text: `${val.text} ${inputUnit ? inputUnit : ''}`,
            value: val.value
          }))}
          value={inputValue}
          onChange={(val) => inputOnChange && inputOnChange(val)}
          disabled={!checked || inputDisabled}
        />
        {hasTStat && (
          <div className="tsat-wrapper">
            <Input
              disabled
              label={t(descriptors.baseline.tStat)}
              value={_.toString(tStatValue)!}
            />
          </div>
        )}
      </div>
    </div>
  );
};
